import React, { useState, useEffect } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import socketService from "../socket/newsocketService";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Select,
  MenuItem as MuiMenuItem,
  FormControl,
  InputLabel,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { getDatabase, ref, onValue, update } from "firebase/database";
import { useDispatch } from "react-redux";
import { addChatWindow } from "../Redux/Slice/dataSlice";

const options = ["Send WellBeing  Alert"];

const ITEM_HEIGHT = 48;

export default function WellbeingMenu(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [dropdownValue, setDropdownValue] = useState("");
  const [pushNotificationOptions, setPushNotificationOptions] = useState([]);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();

  //console.log("getting props data", props);

  const socketId = props?.props?.socketId || props?.props?.userData?.socketId;
  const userId = props?.props?.userId || props?.props?.id;
  //console.log("socketId", socketId, userId);

  useEffect(() => {
    const db = getDatabase();
    const dbRef = ref(db, "pushnotification");
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const optionsArray = Object.entries(data).map(([key, value]) => ({ id: key, ...value }));
        setPushNotificationOptions(optionsArray);
      }
    });
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (option) => {
    var socketId = props?.props?.socketId || props?.props?.userData?.socketId;
    var userId = props?.props?.userId || props?.props?.id;

    if (option === 0) {
      const nowMs = Date.now();
      socketService.emit("emitwellbeingcheck", { socketId: socketId, userId: userId });
      socketService.emit("manual_wellbeing_check", { socketId: socketId, userId: userId });
      if (userId) {
        try {
          const db = getDatabase();
          update(ref(db, `users/${userId}`), {
            Wellbeing_Response: "Awaiting Response",
            wellbeingResponse: "Awaiting Response",
            wellbeingCheckSource: "Sent by Escort Staff",
            wellbeingSentAt: nowMs,
            wellbeingPushStatus: "Delivered",
            userFBK: null,
            userFeedback: null,
            feedback: null,
          });
          localStorage.setItem(`wb_sent_${userId}`, String(nowMs));
          localStorage.setItem(`wb_awaiting_${userId}`, String(nowMs));
          localStorage.removeItem(`wb_resp_dur_${userId}`);
        } catch (e) {
          console.warn("Firebase update notice:", e);
        }
      }
      toast.info(`Wellbeing check alert sent to the user and timer started`, {
        autoClose: 3000,
        position: toast.POSITION.TOP_CENTER,
      });
    }

    setAnchorEl(null);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSendPushNotification = () => {
    var userId = props?.props?.userId || props?.props?.id;
    const selectedOption = pushNotificationOptions.find(o => (o.id && o.id === dropdownValue) || o.title === dropdownValue || o.action === dropdownValue);
    const actionVal = selectedOption?.action || dropdownValue || "notification";
    const titleVal = selectedOption?.title || "Notification";
    const msgVal = selectedOption?.body || selectedOption?.message || "You have a new alert";
    const nowMs = Date.now();

    socketService.emit("pushnotificationevent", { userId: userId, action: actionVal });

    socketService.emit("sendcustompushnotification", {
      userId: userId,
      action: actionVal,
      title: titleVal,
      message: msgVal,
      source: "escort",
      fromEscort: "true",
      vibrate: true,
    });

    const isWellbeingAction = actionVal === "wellbeingcheck" || String(actionVal).toLowerCase().includes("wellbeing");
    if (isWellbeingAction) {
      socketService.emit("manual_wellbeing_check", {
        userId: userId,
        action: actionVal,
        title: titleVal,
        message: msgVal,
        source: "escort",
        fromEscort: "true",
        vibrate: true,
      });

      if (userId) {
        try {
          const db = getDatabase();
          update(ref(db, `users/${userId}`), {
            Wellbeing_Response: "Awaiting Response",
            wellbeingResponse: "Awaiting Response",
            wellbeingCheckSource: "Sent by Escort Staff",
            wellbeingSentAt: nowMs,
            wellbeingPushStatus: "Delivered",
            userFBK: null,
            userFeedback: null,
            feedback: null,
          });
          localStorage.setItem(`wb_sent_${userId}`, String(nowMs));
          localStorage.setItem(`wb_awaiting_${userId}`, String(nowMs));
          localStorage.removeItem(`wb_resp_dur_${userId}`);
        } catch (e) {
          console.warn("Firebase update notice:", e);
        }
      }
    }

    toast.info(isWellbeingAction ? "Wellbeing Check Sent and response timer started" : "Push Notification Sent");
    setOpenModal(false);
  };

  const handleDropdownChange = (event) => {
    //  console.log(event.target.value);
    setDropdownValue(event.target.value);
  };

  return (
    <div>
      {openModal && (
        <Dialog
          open={openModal}
          onClose={handleCloseModal}
          fullWidth
          style={{ minHeight: "400px" }}
        >
          <DialogTitle>Send Push Notification</DialogTitle>
          <DialogContent style={{ height: "140px" }}>
            <FormControl fullWidth style={{ marginTop: 5 }}>
              <InputLabel id="dropdown-label">Select Option</InputLabel>
              <Select
                labelId="dropdown-label"
                value={dropdownValue}
                label="Select Option"
                onChange={handleDropdownChange}
                style={{ width: "100%", height: 50 }}
              >
                {pushNotificationOptions.length > 0 ? (
                  pushNotificationOptions.map((option, index) => (
                    <MuiMenuItem key={option.id || index} value={option.id || option.title || option.action}>
                      {option.title}
                    </MuiMenuItem>
                  ))
                ) : (
                  <MuiMenuItem value="">No Options Available</MuiMenuItem>
                )}
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseModal} color="primary">
              Cancel
            </Button>
            <Button
              onClick={() => {
                toast.info(`Push Notification Sent `, {
                  autoClose: 3000,
                  position: toast.POSITION.TOP_CENTER,
                });
                handleSendPushNotification();
              }}
              color="primary"
            >
              Send
            </Button>
          </DialogActions>
        </Dialog>
      )}
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        slotProps={{
          paper: {
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: "25ch",
            },
          },
        }}
      >
        {options.map((option, index) => (
          <MenuItem key={option} onClick={() => handleClose(index)}>
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
